<template>
  <Popover v-bind="{ ...props }" :getPopupContainer="getPopupContainer">
    <slot></slot>
    <template v-for="(slot, name) in $slots" #[name]="slotData">
      <slot v-if="slot" :name="name" v-bind="slotData"></slot>
    </template>
  </Popover>
</template>

<script lang="ts" setup>
import { Popover } from 'ant-design-vue';
import { popoverProps } from 'ant-design-vue/es/popover/index';
import { nextTick, onMounted, ref } from "vue"
const props = defineProps({
  ...popoverProps(),
  containerId: {
    type: String,
  }
});

// const localContainer = ref<HTMLElement | undefined>(document.body);

const getPopupContainer = function () {
  const targetContainer = document.getElementById("render-control-panel")
  if (targetContainer) {
    // console.warn("挂载容器是：render-control-panel")
    return targetContainer
  } else {
    // console.warn("挂载容器是：body")
    return document.body
  }
}

onMounted(() => {
  nextTick(() => {
    getPopupContainer()
  })
})

</script>
